import { Injectable } from '@angular/core';
import { ProductSectionViewModel } from '../../product-section/product-section-view-model';
import { Observable } from 'rxjs';
import { ReportNewProductsSection } from '../../../../../../../../../models/menu/section/report/report-new-products-section';

@Injectable()
export class ReportNewProductsSectionViewModel extends ProductSectionViewModel {
  public override section$: Observable<ReportNewProductsSection>;

  // public readonly nPotentialVisibleVariants$ = combineLatest([this.menu$, this.section$, this.locationConfig$]).pipe(
  //   map(([menu, section, locConfig]) => {
  //     const priceFormat = locConfig?.priceFormat;
  //     const sectionOverflow = menu?.isSectionLevelOverflow();
  //     // this will give an accurate count based on if the products would have actually been visible on the menu
  //     return section?.getScopedVisibleVariantsBeforeFragmentedAndDoNotIncludeRowCountLimiter(
  //       menu,
  //       priceFormat,
  //       sectionOverflow
  //     );
  //   }),
  //   shareReplay({ bufferSize: 1, refCount: true })
  // );

  // public showPlusXMore$ = this.section$.pipe(
  //   switchMap((section: ReportNewProductsSection) => {
  //     return this.nPotentialVisibleVariants$.pipe(
  //       map(potentialVisibleVariants => {
  //         return (
  //           section?.lastFragmentOfSection &&
  //           section?.rowCount > 0 &&
  //           potentialVisibleVariants?.length > section?.rowCount
  //         );
  //       })
  //     );
  //   })
  // );
  //
  // public nMoreNewProducts$ = combineLatest([this.section$, this.nPotentialVisibleVariants$]).pipe(
  //   map(([section, potentialVisibleVariants]) => {
  //     return section?.rowCount > 0 ? potentialVisibleVariants?.length - section?.rowCount : 0;
  //   })
  // );
}
